import { useEditorState } from '@tiptap/react';
import { useCallback, useEffect } from 'react';
import { Popper } from '@mui/material';
import { usePopover } from 'hooks/common/usePopover';

import { MenuProps } from '../../../components/menus/types';
import { getRenderContainer } from '../../../lib/utils/getRenderContainer';
import { Toolbar } from '../../../components/ui/Toolbar';
import { ColumnLayout } from '../Columns';
import { Icon } from '../../../components/ui/Icon';

export const ColumnsMenu = ({ editor, appendTo }: MenuProps) => {
  const { anchorEl, open, openPopover, closePopover } =
    usePopover<HTMLElement>();

  const shouldShow = useCallback(() => {
    const isColumns = editor.isActive('columns');
    return isColumns;
  }, [editor]);

  const onColumnLeft = useCallback(() => {
    editor.chain().focus().setLayout(ColumnLayout.SidebarLeft).run();
  }, [editor]);

  const onColumnRight = useCallback(() => {
    editor.chain().focus().setLayout(ColumnLayout.SidebarRight).run();
  }, [editor]);

  const onColumnTwo = useCallback(() => {
    editor.chain().focus().setLayout(ColumnLayout.TwoColumn).run();
  }, [editor]);

  const { isColumnLeft, isColumnRight, isColumnTwo } = useEditorState({
    editor,
    selector: (ctx) => {
      return {
        isColumnLeft: ctx.editor.isActive('columns', {
          layout: ColumnLayout.SidebarLeft,
        }),
        isColumnRight: ctx.editor.isActive('columns', {
          layout: ColumnLayout.SidebarRight,
        }),
        isColumnTwo: ctx.editor.isActive('columns', {
          layout: ColumnLayout.TwoColumn,
        }),
      };
    },
  });

  // Update menu position when columns are selected
  const updateMenuPosition = useCallback(() => {
    if (
      !editor.isActive ||
      !editor.view ||
      !shouldShow() ||
      !appendTo?.current
    ) {
      closePopover();
      return;
    }

    const renderContainer = getRenderContainer(editor, 'columns');
    if (!renderContainer) {
      closePopover();
      return;
    }

    // Position at the top of the columns
    const rect = renderContainer.getBoundingClientRect();

    // Use the appendTo container directly
    openPopover(appendTo.current);

    // If needed, set position data attributes for custom positioning
    if (anchorEl) {
      const popoverElement = anchorEl as HTMLElement;
      popoverElement.dataset.x = `${rect.left + rect.width / 2}`;
      popoverElement.dataset.y = `${rect.top}`;
    }
  }, [editor, shouldShow, openPopover, closePopover, appendTo, anchorEl]);

  // Set up event listeners
  useEffect(() => {
    const onSelectionChange = () => {
      if (shouldShow()) {
        updateMenuPosition();
      } else {
        closePopover();
      }
    };

    editor.on('selectionUpdate', onSelectionChange);
    editor.on('update', onSelectionChange);

    // Run once on mount
    if (shouldShow()) {
      updateMenuPosition();
    }

    return () => {
      editor.off('selectionUpdate', onSelectionChange);
      editor.off('update', onSelectionChange);
    };
  }, [editor, updateMenuPosition, shouldShow, closePopover]);
  console.log('asdlvasdfkljvasdkjbasdkljbdsa', open, shouldShow());
  return (
    <Popper
      open={open && shouldShow()}
      anchorEl={anchorEl}
      placement='top'
      className='asdlvasdfkljvasdkjbasdkljbdsa'
      modifiers={[
        {
          name: 'offset',
          options: {
            offset: [0, 10],
          },
        },
        {
          name: 'flip',
          options: {
            fallbackPlacements: ['bottom', 'right', 'left'],
          },
        },
        {
          name: 'preventOverflow',
          options: {
            boundary: 'viewport',
            padding: 8,
          },
        },
      ]}
      style={{
        zIndex: 9999,
      }}
      container={appendTo?.current}
    >
      <Toolbar.Wrapper>
        <Toolbar.Button
          tooltip='Sidebar left'
          active={isColumnLeft}
          onClick={onColumnLeft}
        >
          <Icon name='PanelLeft' />
        </Toolbar.Button>
        <Toolbar.Button
          tooltip='Two columns'
          active={isColumnTwo}
          onClick={onColumnTwo}
        >
          <Icon name='Columns2' />
        </Toolbar.Button>
        <Toolbar.Button
          tooltip='Sidebar right'
          active={isColumnRight}
          onClick={onColumnRight}
        >
          <Icon name='PanelRight' />
        </Toolbar.Button>
      </Toolbar.Wrapper>
    </Popper>
  );
};

export default ColumnsMenu;
